import { createAsyncThunk } from '@reduxjs/toolkit';
import { assertError } from './asserts/assertError';

import { EType } from '../../repositories/sms/entities/PublicValidationCode/PublicSendValidationCodeRequest';
import { fetchSendValidationCode, TSendValidationCodeResponse } from '../../repositories/sms/v2/send-validation-code';
import { selectFormPhone } from '../../selectors/requestFormV2';
import { setErrors, setFormStep } from '../../slices/requestFormV2';
import { IThunkApi } from '../../types/redux/store';
import { EFormStep } from '../../types/requestForm/requestFormV2';
import { mapResponseErrors, ResponseError } from '../../utils/errors';
import { clearPhone } from '../../utils/phone';

interface IThunkApiExtended extends IThunkApi {
  rejectValue: number;
}

export const requestPhoneVerificationCode = createAsyncThunk<number, void, IThunkApiExtended>(
  'phoneVerification/requestPhoneVerificationCode',
  async (parameters, { extra: context, getState, rejectWithValue, dispatch }) => {
    const { httpApi } = context;
    const state = getState();
    const phone = selectFormPhone(state);

    try {
      if (!phone) {
        throw new ResponseError({
          message: 'Необходимо заполнить телефон',
          domain: 'requestPhoneVerificationCode',
          details: mapResponseErrors([{ key: 'customerPhone', message: 'Необходимо заполнить телефон' }]),
        });
      }

      const preparedPhone = phone ? `+${clearPhone(phone)}` : '';

      const response: TSendValidationCodeResponse = await fetchSendValidationCode({
        httpApi,
        parameters: { phone: preparedPhone, type: EType.NewBuildingCallbackForm },
      });

      assertError(response);

      dispatch(setFormStep(EFormStep.PhoneVerification));

      return response.response.secondsToRetry || 0;
    } catch (error) {
      const { customerPhone, phoneVerification } = error.details;

      // Если ошибка связана с запросом кода, то переходим на этап с кодом
      if (phoneVerification) {
        dispatch(setFormStep(EFormStep.PhoneVerification));
      }

      if (customerPhone) {
        dispatch(setFormStep(EFormStep.Contacts));
      }

      dispatch(
        setErrors({
          phone: customerPhone,
          phoneVerification,
        }),
      );

      return rejectWithValue(0);
    }
  },
);
